export default "__VITE_ASSET__DTmN$Rom__"